import React, { useState, useEffect } from "react";
import "./home.css";
import moment from "moment";
import { BiChevronRight } from "react-icons/bi";
import { MdOutlineMessage } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getPosts } from "../../actions/posts";
import { Link, NavLink, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { BiSearch } from 'react-icons/bi'
import Share from "./share";
import CommentSection from "./commentSection";
import Like from "./Like";

function Home({ loginUser }) {
  const date = new Date();
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  var displaytodaysdate = (days[date.getDay()]) + ', ' + date.getDate() + ' ' + (months[date.getMonth()]) + ', ' + date.getFullYear();
  
  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')   // replace non-alphanumeric with hyphen
      .replace(/^-+|-+$/g, '')       // remove starting/trailing hyphens
      .replace(/-+/g, '-'); 

  // state to search posts
  const [searchTerm, setSearchTerm] = useState("");

  const checkDuplicateCategory = (inputarray) => {
    const duplicates = inputarray.filter((item, index) => inputarray.indexOf(item) === index);
    return Array.from(new Set(duplicates))
  }

  const [filter, setFilter] = useState([]);
  const filterTemplate = (cat) => {
    const updatedList = posts.filter((x) => x.category?.toLowerCase().trim() === cat.toLowerCase().trim());
    setFilter(updatedList);
  };

  const [active, setActive] = useState('all');
  const [activeall, setActiveall] = useState(true);

  const dispatch = useDispatch();

  const posts = useSelector((state) => state.postReducer);

  const navigate = useNavigate();

  const [pageNumber, setPageNumber] = useState(0);
  const imagePerPage = 10;
  const pagesVisited = pageNumber * imagePerPage;

  const pageCount = Math.ceil(filter.length / imagePerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
    window.scrollTo(0, 120);
  };

  const filteredPosts = Array.isArray(filter)
    ? filter
      .filter((val) =>
        searchTerm === "" ? true : val.topic.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .sort((a, b) => moment(b.createdAt) - moment(a.createdAt))
      .slice(pagesVisited, pagesVisited + imagePerPage)
    : [];


  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  useEffect(() => {
    setFilter(posts);
  }, [posts, navigate]);

  // this is to get all posts likes
  const likeState = useSelector((state) => state.likeReducer);

  return (
    <>
      <div className="home-container">
        {/* don't use posts exac */}
        {!posts.length ? (
          <div className="loading" style={{ paddingBottom: "30px" }}></div>
        ) : (

          <div>
            <div className="home-banner">
              <div className="container">
                <div className="bannerTop">
                  <img src="https://res.cloudinary.com/hayteetech/image/upload/v1751975208/inspiredformen/logo_plcjyg.png" loading="lazy" alt="logo" />
                  <div className="right">
                    {loginUser ? <span className="bannerLoginText">Welcome, {loginUser.firstName} </span>
                      :
                      <NavLink to="/login" className="bannerLogin">
                        Login
                      </NavLink>}
                  </div>
                </div>
                <div className="banner-text">

                  <div className="banner-content">
                    <div className="welcome">Welcome!!!</div>
                    <div className="animate-container">
                      <h1 className="animate-character"><span> INSPIRED FOR MEN</span></h1>
                    </div>

                    <p>
                      For Men: Impacting life, fulfilling destinies
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="home-about doNotShowonLargeScreen">
              <div className="image">
                <img src='https://res.cloudinary.com/hayteetech/image/upload/v1751975207/inspiredformen/logo1_sqe4au.jpg' loading="lazy" alt="Tobiloba" />
              </div>
              <div className="text">
                <div className='aboutMe'>Hello,</div>
                <div className="aboutMe">
                  My name is <span>Oluwatobi Obalana</span>, and I am pleased to introduce 
                  "Inspired For Men" – <span>www.inspiredformen.com</span>, a platform created to address the deep-rooted societal 
                  and psychological burdens placed on African men by traditional expectations of manhood.
                </div>
                <div className="aboutMe">
                  For generations, men have been conditioned to suppress emotions and maintain a stoic exterior—often at the cost of their mental, emotional, and psychological well-being. Inspired For Men seeks to challenge and reshape that narrative. It provides a space for cultural and psychological transformation—where men can find healing, purpose, and brotherhood.
                </div>
                <div className="aboutMe">
                  This platform is a safe and judgment-free zone for men to share their experiences, support one another, and pursue emotionally balanced, fulfilling lives. It fosters open conversations around mental health, personal growth, and the development of godly, healthy men committed to building a better society.
                </div>
                <div className="aboutMe">
                  I invite you to join the movement. Let’s begin the conversation. Let’s inspire change—together
                </div>
                <div className="aboutMe">
                  <strong>#InspiredForMen</strong>
                </div>
              </div>
            </div>


            <div className="home-content">
              <div className="container">

                <div className="forumContainer">
                  <div className="left">
                    <div className="text">Inspired for men Forum</div>
                    <div className="text">Inspired for men Forum</div>
                  </div>
                  <div className="right">
                    <span>{displaytodaysdate}</span>
                  </div>
                </div>

                <div className="searchContainer">
                  <div className="searchWrapper">
                    <input type="text" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} placeholder="Search Topic" />
                    <div className="searchBtn" onClick={() => setSearchTerm(searchTerm)}>
                      <BiSearch className="icon" />
                    </div>
                  </div>
                </div>

                <div className="display-posts">

                  <div className="row">
                    <div className="col-lg-3 col-md-12 col-sm-12 order-md-2" style={{ paddingBottom: '20px' }}>
                      <div className="home-category">
                        <div className="text">Search post by Category ({posts.length})</div>

                        <div className={activeall ? "category categoryactive" : 'category'} value="all"
                          onClick={() => {
                            setFilter(posts)
                            setActive(null)
                            setActiveall(true)
                          }}
                        >
                          All category
                        </div>
                        {checkDuplicateCategory(posts.map((category) => {
                          return category.category
                        }))
                          .map((value, index) => {
                            return (
                              <div key={index} onClick={() => {
                                setActive(index)
                                filterTemplate(value)
                                setActiveall(false)
                                setPageNumber(0)
                              }}
                                className={active === index ? "category categoryactive" : 'category'}
                              >
                                {value}
                              </div>
                            )
                          })
                        }
                      </div>

                      <div className="home-about doNotShowonMobile">
                        <div className="image">
                          <img src='https://res.cloudinary.com/hayteetech/image/upload/v1751975207/inspiredformen/logo1_sqe4au.jpg' loading="lazy" alt="Tobiloba" />
                        </div>
                        <div className="text">
                          <div className='aboutMe'>Hello,</div>
                          <div className="aboutMe">
                            My name is <span>Oluwatobi Obalana</span>, and I am pleased to introduce 
                            "Inspired For Men" – <span>www.inspiredformen.com</span>, a platform created to address the deep-rooted societal 
                            and psychological burdens placed on African men by traditional expectations of manhood.
                          </div>
                          <div className="aboutMe">
                            For generations, men have been conditioned to suppress emotions and maintain a stoic exterior—often at the cost of their mental, emotional, and psychological well-being. Inspired For Men seeks to challenge and reshape that narrative. It provides a space for cultural and psychological transformation—where men can find healing, purpose, and brotherhood.
                          </div>
                          <div className="aboutMe">
                            This platform is a safe and judgment-free zone for men to share their experiences, support one another, and pursue emotionally balanced, fulfilling lives. It fosters open conversations around mental health, personal growth, and the development of godly, healthy men committed to building a better society.
                          </div>
                          <div className="aboutMe">
                            I invite you to join the movement. Let’s begin the conversation. Let’s inspire change—together
                          </div>
                          <div className="aboutMe">
                            <strong>#InspiredForMen</strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-9 col-md-12 col-sm-12 order-md-1">
                      {Array.isArray(filter) ? (
                        filteredPosts.length > 0 ? (
                          filteredPosts.map((post, i) => {
                            const postLikes = likeState.likes[post.id] || [];
                            const liked = postLikes.includes(loginUser?.id);
                            return (
                              <div className="post-row" key={i}>
                                <div className="top">
                                  <div className="posterby">{post.postername}</div>
                                  <div className="date">
                                    {moment(post.createdAt).format("DD")}/
                                    {moment(post.createdAt).format("MM")}/
                                    {moment(post.createdAt).format("YYYY")}
                                  </div>
                                </div>

                                <div
                                  className="blogpost-nav"
                                >
                                  <div className="post-container">
                                    <div className='postLogo'>
                                      <img src='https://res.cloudinary.com/hayteetech/image/upload/v1751975208/inspiredformen/logo_plcjyg.png' loading="lazy" alt="logo" />
                                    </div>
 
                                    <div className="other-content">
                                    {/* <Link
                                        to={`/${post.topic.split(" ").join("-")}`}
                                        className="blogpost-nav post-topic"
                                      >
                                        {post.topic} - <span>Inspired For Men</span>
                                    </Link> */}

                                    <Link to={`/${slugify(post.topic)}`}
                                    className="blogpost-nav post-topic"
                                    >
                                      <strong>{post.topic}</strong> - <span>Inspired For Men</span>
                                    </Link>
                                   
                                      <div className="category">
                                        Topics <span><BiChevronRight /></span> Forums <BiChevronRight /> General Discussions <span><BiChevronRight /></span> {post.category}
                                      </div>
                                      {/* <a href="https://inspiredformen.com" target="_blank" rel="noopener noreferrer">inspiredformen.com</a> */}
                                      <div className="likeShare">
                                        <Like
                                          likeState={likeState}
                                          posts={posts}
                                          post={post}
                                          loginUser={loginUser}
                                          postLikes={postLikes}
                                          liked={liked}
                                        />
                                        <div className="commentCount">
                                          <MdOutlineMessage style={{ fontSize: '20px' }} className="icon" />
                                          <CommentSection postId={post.id} countOnly />
                                        </div>
                                        <div className="share">
                                          <span className="shareText">
                                            {post && <Share post={post} />}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          })
                        ) : (
                          <div className="noMatch">No match found.</div>
                        )
                      ) : (
                        <div>Loading...</div>
                      )}

                      <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        marginPagesDisplayed={3}
                        pageRangeDisplayed={6}
                        containerClassName={"paginationBttns"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        activeClassName={"paginationActive"}
                      />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Home;